<template lang="pug">
el-dialog(
  :visible.sync="showModal"
  width="80%"
  :show-close="false"
  append-to-body
  custom-class="cadastro-visualizar-documento"
  @closed="aoFechar"
)
  .cadastro-visualizar-documento__header
    h2.cadastro-visualizar-documento__titulo {{ titulo }}
    button.cadastro-visualizar-documento__fechar(
      type="button"
      aria-label="Fechar"
      @click="fechar"
    )
      img(
        src="@/assets/icons/cadastro/x.svg"
        alt=""
      )

  .cadastro-visualizar-documento__corpo
    .cadastro-visualizar-documento__loading(v-if="carregando")
      span Carregando documento...

    template(v-else-if="urlDocumento")
      iframe.cadastro-visualizar-documento__iframe(
        v-if="ehPdf"
        :src="urlDocumento"
        title="Visualização do documento"
      )
      img.cadastro-visualizar-documento__imagem(
        v-else-if="ehImagem"
        :src="urlDocumento"
        :alt="titulo"
      )
      .cadastro-visualizar-documento__indisponivel(v-else)
        img(
          src="@/assets/icons/cadastro/file-text.svg"
          alt=""
        )
        p Este formato não pode ser visualizado no navegador.
        a.cadastro-visualizar-documento__download(
          :href="urlDocumento"
          :download="titulo"
        ) Baixar arquivo

    .cadastro-visualizar-documento__indisponivel(v-else)
      p Não foi possível carregar o documento.
</template>

<script>
const EXTENSOES_IMAGEM = ['png', 'jpg', 'jpeg', 'gif', 'webp']

export default {
  name: 'CadastroVisualizarDocumentoDialog',
  props: {
    aberto: {
      type: Boolean,
      default: false
    },
    titulo: {
      type: String,
      default: 'Visualizar documento'
    },
    urlDocumento: {
      type: String,
      default: null
    },
    extensao: {
      type: String,
      default: ''
    },
    carregando: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showModal: {
      get () {
        return this.aberto
      },
      set () {
        this.fechar()
      }
    },
    extensaoNormalizada () {
      return (this.extensao || '').toLowerCase().replace('.', '')
    },
    ehPdf () {
      return this.extensaoNormalizada === 'pdf'
    },
    ehImagem () {
      return EXTENSOES_IMAGEM.includes(this.extensaoNormalizada)
    }
  },
  methods: {
    fechar () {
      this.$emit('fechar')
    },
    aoFechar () {
      this.$emit('fechar')
    }
  }
}
</script>

<style lang="scss">
.cadastro-visualizar-documento {
  border: 1px solid #eaeaea;
  border-radius: 8px;
  margin-top: 8vh !important;
  max-width: calc(100vw - 32px);

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    color: #141414;
    padding: 20px;
  }
}
</style>

<style lang="scss" scoped>
.cadastro-visualizar-documento__header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  position: relative;
}

.cadastro-visualizar-documento__titulo {
  color: #141414;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.4;
  margin: 0;
  overflow: hidden;
  padding-right: 48px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cadastro-visualizar-documento__fechar {
  align-items: center;
  background: transparent;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  height: 40px;
  justify-content: center;
  position: absolute;
  right: 0;
  top: -1px;
  width: 40px;

  img {
    display: block;
    height: 16px;
    width: 16px;
  }
}

.cadastro-visualizar-documento__corpo {
  min-height: 320px;
}

.cadastro-visualizar-documento__loading,
.cadastro-visualizar-documento__indisponivel {
  align-items: center;
  color: #8a8a8a;
  display: flex;
  flex-direction: column;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 14px;
  gap: 12px;
  justify-content: center;
  min-height: 320px;
  text-align: center;

  img {
    height: 32px;
    width: 32px;
  }

  p {
    margin: 0;
  }
}

.cadastro-visualizar-documento__iframe {
  border: 1px solid #eaeaea;
  border-radius: 8px;
  height: 70vh;
  width: 100%;
}

.cadastro-visualizar-documento__imagem {
  border: 1px solid #eaeaea;
  border-radius: 8px;
  display: block;
  margin: 0 auto;
  max-height: 70vh;
  max-width: 100%;
  object-fit: contain;
}

.cadastro-visualizar-documento__download {
  background: #1e174e;
  border-radius: 8px;
  color: #ffffff;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 14px;
  font-weight: 500;
  padding: 10px 16px;
  text-decoration: none;
}
</style>
